import { embed } from 'pdfobject';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

const defaultOptions = {
  page: 1,
  name: 'pdf',
  pdfOpenParams: {
    navpanes: 1,
    view: 'FitH',
    pagemode: 'none',
  },
};

@Component
export default class PdfObjectComponent extends Vue {
  @Prop({ type: String, required: true })
  public value!: string;

  @Prop({ default: () => defaultOptions })
  public options: any;

  @Watch('value')
  renderPDF(newValue: string) {
    embed(newValue, '#pdfContainer', this.options);
  }
}
